/**
 * 获取真正的Validation数据
 * @param filter         公共过滤器数据
 * @param isExcludeInvalid   是否排除is_valid === 0的数据
 */
export const getRealValidation = (filter: any, isExcludeInvalid: boolean) => {
  // 如果不排除，直接返回就好
  if (!isExcludeInvalid) {
    return filter;
  }
  const is_valid = (filter?.is_valid || []).filter(
    (item: number) => item !== 0,
  );

  // 如果长度 === 0，全选，去掉0
  if (is_valid.length === 0) {
    return { ...filter, is_valid: [1, 2, 3] };
  }

  // 直接过滤掉0
  return { ...filter, is_valid };
};

/**
 * 获取真正的keyword数据
 * 以params参数为主，但是如果params的keyword没有数据，那么就以filter过滤器keyword为主
 * @param filter         公共过滤器数据
 * @param commonParams   公共参数
 */
export const getRealKeywords = (filter: any, params: any) => {
  const { keyword: filterKeyword, ...otherFilter } = filter;
  const { keyword, ...otherParams } = params;

  return {
    ...otherFilter,
    ...otherParams,
    keyword: keyword?.length > 0 ? keyword : filterKeyword || [],
  };
};

/**
 * 获取真正的参数数据
 * @param filter         公共过滤器数据
 * @param commonParams   公共参数
 * @param isExcludeInvalid   是否排除is_valid === 0的数据
 */
export const getRealParams = ({
  filter,
  commonParams,
  isExcludeInvalid,
}: {
  filter: any;
  commonParams: any;
  isExcludeInvalid: boolean;
}) => {
  const realParams = getRealValidation(
    getRealKeywords(filter, commonParams),
    isExcludeInvalid,
  );

  return realParams;
};
